import React from "react";
import BootstrapModal from "react-bootstrap/Modal";

// Focusing inside an iframe makes the parent page scroll the iframe into view.
export const isEmbedded = window.self !== window.top;

const Modal = React.forwardRef((props, ref) => (
  <BootstrapModal
    autoFocus={!isEmbedded}
    enforceFocus={!isEmbedded}
    restoreFocus={!isEmbedded}
    {...props}
    ref={ref}
  />
));

Modal.Header = BootstrapModal.Header;
Modal.Title = BootstrapModal.Title;
Modal.Body = BootstrapModal.Body;
Modal.Footer = BootstrapModal.Footer;
Modal.Dialog = BootstrapModal.Dialog;

export default Modal;
